export default "__VITE_ASSET__BJjkLpcW__"